import {
  DeleteTwoTone,
  PlusCircleTwoTone,
  SaveOutlined,
  setTwoToneColor,
} from '@ant-design/icons';
import { Alert, Input, Modal } from 'antd';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Sort } from 'src/icons/Sort.icon';
import { getConditionListAction } from 'src/modules/SuperAdmin/store/actions/condition.action';
import { getAllActiveOrganizationAction } from 'src/modules/SuperAdmin/store/actions/organization.action';
import {
  getConditionMappings,
  updateMappings,
} from 'src/store/actions/appointment.action';
import { getOrgSetting } from 'src/store/actions/settings.action';
import { getFromStorage } from '../../../../../../lib/storage';
import organizationEventEmitter from '../../../../../../utilities/organizationEmmiter';
import { SuperAdminTable } from '../../../baseComponents/Table';

const ConditionMappingPage = () => {
  const dispatch = useDispatch();

  setTwoToneColor('red');
  const { getActiveOrganizationsList } = useSelector(
    (state) => state?.organizationState
  );
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const [bulkCSVUploadEnabled, setBulkCSVUploadEnabled] = useState(
    currentPractitioner?.org_settings?.enable_bulk_appointment_upload ?? false
  );
  const { getAllConditionsList } = useSelector(
    (state) => state?.conditionState
  );
  const { conditionMappings, conditionMappingsLoading } = useSelector(
    (state) => state?.appointmentState
  );
  const [selectedOrganizationUuid, setSelectedOrganizationUuid] = useState(
    () => {
      const savedOrg = getFromStorage('superAdminSelectedOrganization');
      const parsedSavedOrg = savedOrg ? JSON.parse(savedOrg) : null;
      return parsedSavedOrg?.org_uuid || currentPractitioner?.org_uuid || null;
    }
  );

  const [_selectedOrganizationName, setSelectedOrganizationName] =
    useState(null);
  const [_organizationDropdown, setOrganizationDropdown] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [updatedValues, setUpdatedValues] = useState({});
  const [tableLoader, setTableLoader] = useState(false);
  const [addedCondition, setAddedCondition] = useState(null);
  const [addConditionBoxVisible, setaddConditionBoxVisible] = useState(false);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [_organizationName, setOrganizationName] = useState(
    currentPractitioner?.org_id
  );

  useEffect(() => {
    dispatch(getAllActiveOrganizationAction());
    dispatch(getConditionListAction());
  }, []);

  useEffect(() => {
    setTableLoader(conditionMappingsLoading);
  }, [conditionMappingsLoading]);

  useEffect(() => {
    dispatch(getConditionMappings(selectedOrganizationUuid));
  }, [selectedOrganizationUuid, dispatch]);

  useEffect(() => {
    if (
      getActiveOrganizationsList &&
      Array.isArray(getActiveOrganizationsList)
    ) {
      let dataArr = [];
      getActiveOrganizationsList.forEach((key) => {
        dataArr.push({
          value: key?.org_id,
          label: key?.org_name,
          org_uuid: key?.org_uuid,
        });
      });
      setOrganizationDropdown(dataArr);
    }
  }, [getActiveOrganizationsList]);

  useEffect(() => {
    if (conditionMappings && getAllConditionsList) {
      let dataArr = [];
      getAllConditionsList.forEach((condition) => {
        dataArr.push({
          key: condition['condition_id'],
          mapping: conditionMappings[condition['condition_name']] ?? [
            condition['condition_name'],
          ],
          recognizedConditionName: condition['condition_name'],
        });
      });
      setTableData(dataArr);

      dataArr = {};
      getAllConditionsList.forEach((condition) => {
        dataArr[condition['condition_name']] = conditionMappings[
          condition['condition_name']
        ] ?? [condition['condition_name']];
      });
      setUpdatedValues(dataArr);
    }
  }, [selectedOrganizationUuid, conditionMappings, getAllConditionsList]);

  useEffect(() => {
    async function getOrgSettingData() {
      await dispatch(getOrgSetting(selectedOrganizationUuid)).then(
        (setting) => {
          setBulkCSVUploadEnabled(
            setting?.enable_bulk_appointment_upload ?? false
          );
        }
      );
    }
    getOrgSettingData();
  }, [selectedOrganizationUuid, dispatch]);

  useEffect(() => {
    const unsubscribe = organizationEventEmitter.subscribe(
      'organizationChanged',
      (newOrg) => {
        setSelectedOrganizationUuid(newOrg);
        handleSelectChange(newOrg);
      }
    );

    return () => unsubscribe();
  }, []);
  const handleSelectChange = (option) => {
    const orgUuid = option?.org_uuid;
    setSelectedOrganizationUuid(orgUuid);
    setSelectedOrganizationName(option?.label);
    setOrganizationName(option?.value);
  };

  const columnNameSorter = (a, b) => {
    return a.recognizedConditionName.localeCompare(b.recognizedConditionName);
  };

  const handleDeleteCondition = (
    recognizedConditionName,
    conditionToDelete
  ) => {
    setUpdatedValues((prevValues) => ({
      ...prevValues,
      [recognizedConditionName]: prevValues[recognizedConditionName].filter(
        (condition) => condition !== conditionToDelete
      ),
    }));
  };

  const columns = [
    {
      title: (
        <span className="font-[700]">
          {' '}
          Condition in Insight{' '}
          <Sort className={'sort-icon-condition-mapping'} />
        </span>
      ),
      dataIndex: 'recognizedConditionName',
      key: 'recognizedConditionName',
      width: '50%',
      sorter: columnNameSorter,
    },
    {
      title: <span className="font-[700]"> Condition name in CSV</span>,
      width: '60%',
      render: (text, record) => {
        const conditionNames = updatedValues[
          record.recognizedConditionName
        ]?.map((condition) => condition?.trim());
        return (
          <div className="flex flex-wrap gap-2">
            {conditionNames?.map((condition, index) => {
              return (
                <div
                  key={index}
                  className="relative group inline-flex items-center px-3 py-1 mt-2 rounded-3xl"
                  style={{ border: `1px solid #00D090` }}
                >
                  <span className="flex-grow text-center group-hover:pr-4 transition-all">
                    {condition}
                  </span>
                  <DeleteTwoTone
                    className="absolute right-1 hidden group-hover:inline-block cursor-pointer rounded-full p-1 transition-all"
                    onClick={() =>
                      handleDeleteCondition(
                        record.recognizedConditionName,
                        condition
                      )
                    }
                  />
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      width: '25%',
      render: (text, record) => {
        return (
          <PlusCircleTwoTone
            twoToneColor="#00D090"
            style={{ fontSize: '19px' }}
            onClick={() => {
              setSelectedCondition(record.recognizedConditionName);
              setaddConditionBoxVisible(true);
            }}
          />
        );
      },
    },
  ];

  const handleAddConditionClose = () => {
    setaddConditionBoxVisible(false);
    setSelectedCondition(null);
    setAddedCondition(null);
  };

  const handleAddConditionSubmit = () => {
    updatedValues[selectedCondition] = [
      ...updatedValues[selectedCondition],
      addedCondition.trim(),
    ];

    setaddConditionBoxVisible(false);
    setSelectedCondition(null);
    setAddedCondition(null);
  };

  const handleFormSubmit = async (_values) => {
    let mapping = {};
    for (const [key, value] of Object.entries(updatedValues)) {
      for (const condition of value) {
        if (condition !== key) {
          mapping[condition] = key;
        }
      }
    }
    let payload = {
      settings: {
        condition_mapping: mapping,
      },
    };
    dispatch(
      updateMappings(payload, selectedOrganizationUuid, 'condition mapping')
    );
  };

  return (
    <>
      <div>
        <Formik initialValues={{}} onSubmit={handleFormSubmit}>
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="flex flex-row sm:justify-between gap-4 lg:justify-between items-center">
                <div className="flex flex-col justify-center"></div>
                {bulkCSVUploadEnabled && (
                  <div className="flex justify-end">
                    <div className="flex justify-end items-end">
                      <button
                        type="submit"
                        className="bg-[#00D090] hover:bg-[#059669] flex items-center justify-center text-white font-normal p-2 py-2 px-4 rounded-xl focus:outline-none focus:shadow-outline"
                      >
                        <SaveOutlined
                          className={`mr-2`}
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                        />{' '}
                        Save all
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {bulkCSVUploadEnabled ? (
                <div className="super-admin-table">
                  <div className="mt-5 ant-table rounded-xl shadow-xl">
                    <SuperAdminTable
                      className={`appointment-page-table`}
                      columns={columns}
                      data={tableData}
                      loading={tableLoader}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex justify-center items-center p-4 min-h-[60vh]">
                  <Alert
                    message="Bulk CSV uploads are currently disabled for this organization."
                    type="info"
                    showIcon
                  />
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
      <Modal
        open={addConditionBoxVisible}
        closable={false}
        centered={true}
        styles={{ body: { height: '80px' } }}
        footer={[
          <div key="footer" className="flex justify-end gap-1">
            <button
              key="back"
              className="bg-[#A9A9A9] hover:bg-[#899499] text-white font-normal p-1 py-1 px-2 rounded-md focus:outline-none focus:shadow-outline"
              onClick={handleAddConditionClose}
            >
              Cancel
            </button>
            <button
              key="submit"
              className="bg-[#00D090] hover:bg-[#059669] text-white font-normal p-1 py-1 px-2 rounded-md focus:outline-none focus:shadow-outline"
              onClick={handleAddConditionSubmit}
              disabled={!addedCondition || addedCondition.trim() === ''}
            >
              Add condition
            </button>
          </div>,
        ]}
      >
        <div className="mb-4 flex flex-col gap-2">
          <p className="text-md">{selectedCondition}</p>
        </div>
        <div>
          <Input
            placeholder="Enter condition name"
            onChange={(e) => setAddedCondition(e.target.value)}
            value={addedCondition}
          />
        </div>
      </Modal>
    </>
  );
};

export default ConditionMappingPage;
